import { Alert, Button, Stack, Text } from '@mantine/core';

/** A failed catalogue read, with a retry in place. There is no order to
 * place without a catalogue: the backend prices the order from it. */
export function CatalogueErrorAlert({
  error,
  onRetry,
}: Readonly<{ error: Error; onRetry: () => void }>) {
  return (
    <Alert color="red" title="Could not load the document catalogue">
      <Stack gap="xs">
        <Text size="sm">{error.message}</Text>
        <Button
          size="xs"
          variant="light"
          color="red"
          onClick={onRetry}
          style={{ alignSelf: 'flex-start' }}
          data-testid="registry-order-catalogue-retry"
        >
          Try again
        </Button>
      </Stack>
    </Alert>
  );
}
